const waveform = [
    {
        path: '/waveform/manage',
        name: 'waveformManage',
        component: () => import('@/view/waveform/manage'),
    },
    {
        path: '/waveform/load',
        name: 'waveformLoad',
        component: () => import('@/view/waveform/load'),
    },
    {
        path: '/waveform/model',
        name: 'waveformModel',
        component: () => import('@/view/waveform/model'),
    },
    {
        path: '/waveform/userScenario',
        name: 'waveformUserScenario',
        component: () => import('@/view/waveform/userScenario'),
    },
    {
        path: '/waveform/gateway',
        name: 'waveformGateway',
        component: () => import('@/view/waveform/gateway'),
    },
]
export default waveform